// Écouter l'événement personnalisé pour mettre à jour les frais de livraison
document.addEventListener('cart:toggle', function() {
  displayShippingEstimate();
});

// Définition de la fonction displayShippingEstimate() si elle n'est pas déjà définie
async function displayShippingEstimate() {
  const shippingRatesByWeight = [
    { maxWeight: 0.36, rate: 6.99 },
    { maxWeight: 0.61, rate: 8.10 },
    { maxWeight: 0.86, rate: 8.80 },
    { maxWeight: 1.86, rate: 10.15 },
    { maxWeight: Infinity, rate: 15.60 }
  ];

  const mondialRelayRate = 1.99;
  const freeShippingThreshold = 55.00;

  async function getCartDetails() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  const cart = await getCartDetails();
  let totalWeight = 0;
  cart.items.forEach(item => {
    totalWeight += item.grams * item.quantity;
  });
  totalWeight = totalWeight / 1000;
  const colissimoCost = shippingRatesByWeight.find(rate => totalWeight <= rate.maxWeight).rate;
  const totalPrice = cart.total_price / 100;

  document.getElementById('shipping-estimate').innerHTML = `
  <p>Total livraison Colissimo : ${colissimoCost.toFixed(2)} €</p>
  <p>Total livraison Mondial Relay : ${mondialRelayRate.toFixed(2)} €</p>
`;

  if (totalPrice < freeShippingThreshold) {
    const amountNeeded = (freeShippingThreshold - totalPrice).toFixed(2);
    document.getElementById('free-shipping-message').textContent =
      `Ajoutez ${amountNeeded} € de plus pour bénéficier de la livraison gratuite !`;
  } else {
    document.getElementById('free-shipping-message').textContent = 
      "Félicitations ! Vous bénéficiez de la livraison gratuite.";
  }
}
